













































































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import store from '@/store'
import { SCRIPTS__FETCH } from '@/store/actions'
import { UserActionTypes } from '@/store/modules/users/actions'
import { UserStatus } from '@/models/users'
import { UserMutationTypes } from '@/store/modules/users/mutations'
import DataTableTextInput from '@/components/DataTable/Filters/FilterInputs/DataTableTextInput.vue'
import DataTableBooleanInput from '@/components/DataTable/Filters/FilterInputs/DataTableBooleanInput.vue'
import DataTableDateInput from '@/components/DataTable/Filters/FilterInputs/DataTableDateInput.vue'
import DataTableTimeInput from '@/components/DataTable/Filters/FilterInputs/DataTableTimeInput.vue'
import DataTableBetweenTimeInput from '@/components/DataTable/Filters/FilterInputs/DataTableBetweenTimeInput.vue'
import DataTableBetweenDateInput from '@/components/DataTable/Filters/FilterInputs/DataTableBetweenDateInput.vue'
import DataTableUserNameInput from '@/components/DataTable/Filters/FilterInputs/Records/DataTableUserNameInput.vue'
import DataTableTitleInput from '@/components/DataTable/Filters/FilterInputs/Records/DataTableTitleInput.vue'
import DataTableFinishTypeInput from '@/components/DataTable/Filters/FilterInputs/Records/DataTableFinishTypeInput.vue'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'
import { FilterItem, FinishTypes } from '@/models/dataTable'
import { FILTER_SELECTS, FINISH_TYPE } from '@/constants/dataTable'

interface Options {
  [key: string]: string
}

interface FinishTypesWithTitle extends FinishTypes {
  title: string
}

interface FilterOption {
  value: string
  symbol: string
}

interface Props {
  filterName: string
  filters: Record<string, string>
  filterType: string
}

interface Data {
  inputValue: string
  currentFilter: FilterItem
}

interface Methods {
  changeFilter: (item: FilterItem) => void
  handleSetFilter: (status: UserStatus) => void
  setCurrentFilter: () => void
  changeModel: () => void
  getUsers: () => Promise<void>
}

interface Computed {
  selectItems: Array<FilterItem>
  filterOption: FilterOption
  filterValue: string
  users: Options[]
  scripts: Options[]
  fullNameUsers: Options[]
  notFixDate: boolean
  finishTypes: FinishTypesWithTitle[]
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    iconCaretDown,
    DataTableTextInput,
    DataTableBooleanInput,
    DataTableTimeInput,
    DataTableBetweenTimeInput,
    DataTableBetweenDateInput,
    DataTableDateInput,
    DataTableUserNameInput,
    DataTableTitleInput,
    DataTableFinishTypeInput,
  },
  props: {
    filterName: {
      required: true,
    },
    filters: {
      required: true,
    },
    filterType: {
      required: true,
    },
  },
  data() {
    return {
      inputValue: '',
      currentFilter: {
        name: '',
        symbol: '',
        type: '',
        input: '',
      },
    }
  },
  methods: {
    async getUsers() {
      await store.dispatch(UserActionTypes.FetchCompanyUsers)
      await store.dispatch(SCRIPTS__FETCH)
    },
    ...mapMutations({
      handleSetFilter: UserMutationTypes.Filter,
    }),
    changeFilter(item) {
      this.currentFilter = item
      if (this.currentFilter.input === 'none') {
        this.inputValue = ''
      }
      this.changeModel()
    },
    changeModel() {
      this.$emit('input', {
        ...this.currentFilter,
        value: this.inputValue,
        filter: this.filterName,
      })
    },
    setCurrentFilter() {
      if (this.filterOption.symbol) {
        this.currentFilter = this.selectItems.filter(
          elem => elem.symbol === this.filterOption.symbol,
        )[0]
      } else {
        this.currentFilter = this.selectItems[0]
      }
    },
  },
  computed: {
    ...mapGetters({
      users: 'getUsersFilteredList',
      scripts: 'getScriptsList',
    }),
    filterValue: {
      get() {
        return this.inputValue
      },
      set(value) {
        this.inputValue = value
        this.changeModel()
      },
    },
    selectItems() {
      return FILTER_SELECTS.filter(elem => {
        return elem.type === this.filterType
      })
    },
    filterOption() {
      if (!this.filters[this.filterName]) {
        return { value: '', symbol: '' }
      }
      let symbols: string[] = FILTER_SELECTS.map(elem => {
        return elem.symbol
      })
      symbols = [...new Set(symbols)]
      symbols.sort((a, b) => {
        return b.length - a.length
      })
      if (symbols.includes(this.filters[this.filterName])) {
        return {
          value: '',
          symbol: this.filters[this.filterName],
        }
      }
      return {
        value: this.filters[this.filterName].replace(/^!/, '').slice(1),
        symbol: this.filters[this.filterName].slice(
          0,
          this.filters[this.filterName][0] === '!' ? 2 : 1,
        ),
      }
    },
    fullNameUsers() {
      const newUsers = this.users.map(obj => ({
        ...obj,
        fullName: `${obj.lname} ${obj.fname}`,
      }))
      return newUsers
    },
    notFixDate() {
      return (
        this.currentFilter.symbol === 'D' || this.currentFilter.symbol === '!D'
      )
    },
    finishTypes() {
      return FINISH_TYPE.map(elem => {
        return { ...elem, title: this.$tc('records.finishType.' + elem.id) }
      })
    },
  },
  mounted() {
    this.inputValue = this.filterOption.value
    this.$emit('filtered', this.inputValue && !!this.inputValue.length)
    this.setCurrentFilter()
    this.handleSetFilter(UserStatus.All)
    this.getUsers()
  },
  watch: {
    '$route.query.filter'() {
      this.inputValue = this.filterOption.value
      this.setCurrentFilter()
    },
  },
})
